// extracted by mini-css-extract-plugin
export default {"customBackground":"Hero_customBackground__rpIgv"};